import { X } from "lucide-react";
import Loading from "../../../shared/Loading";
import CustomInput from "../../../shared/CustomInput";
import CustomArea from "../../../shared/CustomArea";

const EditLoanDetails = ({
  closeEditLoanDetails,
  loading,
  loanEditDetails,
  setLoanEditDetails,
  handleUpdateLoanDetails,
}) => {
  const handleChange = (field, value) => {
    setLoanEditDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  return (
    <div
      onClick={() => closeEditLoanDetails()}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[550px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto"
      >
        <div
          onClick={closeEditLoanDetails}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px]">
          Edit Loan Details
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-[20px]">
          Please update the loan details below to ensure accuracy of your loan
          application.
        </p>
        {/* Form Fields */}
        <div className="flex flex-col gap-[20px]">
          <div className="flex items-start justify-between">
            {/* Loan Amount */}
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Loan Amount
              </label>
              <CustomInput
                placeholder="Enter loan amount"
                type="text"
                value={loanEditDetails?.loanAmount || ""}
                onChange={(e) => handleChange("loanAmount", e.target.value)}
              />
            </div>

            {/* Loan Period */}
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Loan Period
              </label>
              <CustomInput
                placeholder="Enter loan duration"
                type="text"
                value={loanEditDetails?.loanPeriod || ""}
                onChange={(e) => handleChange("loanPeriod", e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-start justify-between">
            {/* Loan Purpose */}
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Loan Purpose
              </label>
              <CustomArea
                placeholder="Enter loan purpose"
                type="text"
                value={loanEditDetails?.loanPurpose || ""}
                onChange={(e) => handleChange("loanPurpose", e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditLoanDetails}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleUpdateLoanDetails}
            disabled={loading}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loading && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditLoanDetails;
